import { useState, type FormEvent } from "react";

const FORM_ENDPOINT = "https://readdy.ai/api/form/dagijaptto0ceqqnhsl0";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;

    // 蜜罐检测：命中则静默当作正常提交，不向表单地址发送数据
    const fd = new FormData(form);
    const honeypot = String(fd.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，感谢关注瓜田日报！");
      form.reset();
      return;
    }

    setStatus("loading");
    setMessage("");
    const payload = new URLSearchParams();
    payload.set("email", String(fd.get("email") || "").trim());

    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        responseText ||
        "";

      const isSpam = /spam|form data is spam/i.test(serverMsg);
      if (response.ok && code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功！之后每天的热点晚报会准时送到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(isSpam && serverMsg ? "提交似乎有点问题，请稍后再试。" : serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络出了点问题，请稍后再试。");
    }
  }

  return (
    <section id="newsletter" className="bg-primary-950/95">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-900/60 px-3 py-1 text-xs font-medium text-primary-200">
              <i className="ri-mail-send-line" aria-hidden="true" />
              热点晚报 · 免费订阅
            </p>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              每天一份晚报，热点重点一次讲清
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-primary-100/80">
              留下邮箱，我们会把当天值得一看的热点、正在跟进的大事和精选复盘整理成一份简短晚报发给你。不刷屏，只挑重点。
            </p>
          </div>

          <form
            id="newsletterForm"
            data-readdy-form="dagijaptto0ceqqnhsl0"
            onSubmit={handleSubmit}
            noValidate
            className="rounded-2xl bg-background-50 p-6 md:p-7"
          >
            <label htmlFor="nl-email" className="text-sm font-medium text-foreground-800">
              你的邮箱
            </label>
            <div className="mt-2 flex flex-col gap-3 sm:flex-row">
              <input
                id="nl-email"
                name="email"
                type="email"
                required
                maxLength={120}
                placeholder="you@example.com"
                className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="shrink-0 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
              >
                {status === "loading" ? "提交中…" : "立即订阅"}
              </button>
            </div>

            {/* 蜜罐字段 */}
            <div className="hp-field" aria-hidden="true">
              <input name="company_alt" type="text" tabIndex={-1} autoComplete="off" readOnly />
            </div>

            {status === "success" && (
              <p className="mt-3 flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2 text-sm text-secondary-800">
                <i className="ri-checkbox-circle-fill" aria-hidden="true" />
                {message}
              </p>
            )}
            {status === "error" && (
              <p className="mt-3 flex items-center gap-2 rounded-md bg-primary-100 px-3 py-2 text-sm text-primary-800">
                <i className="ri-error-warning-fill" aria-hidden="true" />
                {message}
              </p>
            )}

            <p className="mt-4 text-xs leading-relaxed text-foreground-400">
              提交即表示你同意接收瓜田日报的热点晚报邮件，可随时退订。
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}